export default "__VITE_ASSET__4xOYqUmR__"